import * as React from 'react';
import { cn } from '@/lib/utils';

/** Platform select for short, fixed option lists, with shared focus and theme tokens. */
const NativeSelect = React.forwardRef<HTMLSelectElement, React.ComponentProps<'select'>>(
  ({ className, ...props }, ref) => <select ref={ref} className={cn(
    'h-10 w-full rounded-control border border-input bg-background px-3 text-sm text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
    className,
  )} {...props} />,
);
NativeSelect.displayName = 'NativeSelect';

export { NativeSelect };
